module.exports = __webpack_public_path__ + "static/media/0.2af58c6e.png";